// import { useEffect, useState } from "react";

// import './app.css';
// import SearchIcon from './search.svg';
// import MovieCard from "./MovieCard";

// const API_URL = 'http://www.omdbapi.com/?i=tt3896198&apikey=fa4168df';



// const App = () => {
//     const [movies, setMovies] = useState([]);

//     const [searchTerm, setSearchTerm] = useState('')

//     const searchMovies = async (title) => {
//         const response = await fetch(`${API_URL}&s=${title}`)
//         const data = await response.json();

//         searchMovies(data.Search)
//     }

//     useEffect(() => {
//         searchMovies('Spiderman')
//     }, []);


//     return (
//         <div className="app">
//             <h1>FilmTopia</h1>

//             <div className="search">
//                 <input
//                     placeholder="Search for movies"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}

//                 />
//                 <img 
//                     src={SearchIcon}
//                     alt="search"
//                     onClick={() => searchMovies(searchTerm)}
//                 />
//             </div>

//             {
//                movies?.length > 0
//                ? (
//                 <div className="container">
//                     {movies.map((movie) => (
//                         <MovieCard movie={movie}/>
//                     ))}
//                 </div>
//                ) : (
//                 <div className="empty">
//                     <h2>No movies found</h2>
//                 </div>
//                )
//             }

            
//         </div>
//     );
// }


// export default App;


import React, { useState, useEffect } from "react";

import MovieCard from "./MovieCard";
import SearchIcon from "./search.svg";
import "./app.css";

const API_URL = 'http://www.omdbapi.com/?i=tt3896198&apikey=fa4168df';
// const API_URL = "http://www.omdbapi.com?apikey=b6003d8a";

const App = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    searchMovies('Avatar');
  }, []);

  const searchMovies = async (title) => {
    const response = await fetch(`${API_URL}&s=${title}`);
    
    const data = await response.json();

    setMovies(data.Search);
  };

  return (
    <div className="app">
      <h1>FilmTopia</h1>

      <div className="search">
        <input
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search for movies"
        />
        <img
          src={SearchIcon}
          alt="search"
          onClick={() => searchMovies(searchTerm)}
        />
      </div>

      {movies?.length > 0 ? (
        <div className="container">
          {movies.map((movie) => (
            <MovieCard movie={movie} />
          ))}
        </div>
      ) : (
        <div className="empty">
          <h2>No movies found</h2>
        </div>
      )}
    </div>
  );
}; 

export default App;